export enum ActionTypes {
 UPDATE_ACCOUNT_VISITS = '[UPDATE_ACCOUNT_VISITS] Update account visits',
 UPDATE_ACCOUNT_VISITS_SUCCESS = '[UPDATE_ACCOUNT_VISITS] Update account visits success',
 UPDATE_ACCOUNT_VISITS_FAILURE = '[UPDATE_ACCOUNT_VISITS] Update account visits failure',
}
